import { useQuery } from '@tanstack/vue-query'
import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { tradingKeys } from '../tradingQueryKeys'
import { getMarketProperty } from '../tradingEndpoints'
import { parseMarketProperty } from '../tradingParser'

// Trading detail for one property (details page, sellers drawer, buy header).
// The rich content (media, description, yields) is the offering's own detail.
export function useMarketPropertyQuery(propertyId: MaybeRefOrGetter<string>) {
  return useQuery({
    queryKey: computed(() => tradingKeys.property(toValue(propertyId))),
    queryFn: () => getMarketProperty(toValue(propertyId)).then(parseMarketProperty),
    enabled: () => Boolean(toValue(propertyId)),
  })
}
